import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { ViewChildren, QueryList } from "@angular/core";

declare var jQuery: any;
import "../../../../assets/semantic/semantic.min.js";
import { IMyDpOptions } from "mydatepicker";
import { FormBuilder, FormGroup, FormControl, FormArray } from "@angular/forms";

import { SecurityService } from "../../../_services/security.service";
import { ToastService } from "../../../_services/toast.service";

import { PlanningService } from "../../../_services/planning.service";
import { PlanningFilesService } from "../../../_services/planning-files.service";
import { PlanningPalettesService } from "../../../_services/planning-palettes.service";

import { WarehouseAutocompleteComponent } from "../../warehouse-autocomplete/warehouse-autocomplete.component";

import { ConfigService } from "../../../_services/config.service";
import { DistanceService } from "../../../_services/distanceService";


import * as moment from 'moment';

@Component({
  selector: "app-planning-modal",
  templateUrl: "./planning-modal.component.html",
  styleUrls: ["./planning-modal.component.css"],
})

export class PlanningModalComponent implements OnInit {
  
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() updatePlanningFiles: EventEmitter<object> = new EventEmitter<object>();

  @ViewChildren('warehousecomp') childWarehouse: QueryList<WarehouseAutocompleteComponent>;
  
  private planning_id: number;
  private is_admin;
  private planning: object;
  private provider_payment_date;
  private client_payment_date;
  private planningFileToUpload: File | null = null;
  private planning_files: Array<Object> | null = null;
  private planning_palettes: Array<Object> | null = null;
  private addPlanningFileLoading: boolean = false;
  private deletePlanningFileLoadingID: Array<number> = [];

  private statuses = [
    { name: 'Facture client vérifiée', checked: false },
    { name: 'Facture client réglée', checked: false },
    { name: 'Relance client', checked: false },
    { name: 'Facture fournisseur vérifiée', checked: false },
    { name: 'Facture fournisseur réglée', checked: false },
    { name: 'Relance fournisseur', checked: false },
  ];
  
  palettes_form: FormGroup;
  planning_form: FormGroup;
  add_palettes_form: FormGroup
  billing_form_arr: FormArray

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd/mm/yyyy",
    openSelectorOnInputClick: true,
    editableDateField: false,
  };

  constructor(
    private service: PlanningService,
    private security: SecurityService,
    private toast: ToastService,
    private planningFilesService: PlanningFilesService,
    private planningPalettesService: PlanningPalettesService,
    private fb: FormBuilder,
    private distanceService: DistanceService,
    private configService: ConfigService,
  ) {}

  get itemsFormArray(): FormArray {
    return this.palettes_form.get('palettes') as FormArray;
  }

  // Method to reset the FormArray
  resetItemsFormArray() {
    while (this.itemsFormArray.length !== 0) {
      this.itemsFormArray.removeAt(0);
    }
  }
  
  ngOnInit() {

    this.planning_form = this.fb.group({
      departure_id: new FormControl(),
      arrival_id: new FormControl(),
      loading_place: new FormControl(),
      loading_hour: new FormControl(),
      ref_loading: new FormControl(),
      shipping_place: new FormControl(),
      shipping_hour: new FormControl(),
      ref_delivery: new FormControl(),
      ref_client: new FormControl(),
      provider_payment_date: new FormControl(),
      client_payment_date: new FormControl(),
      state_billing: new FormArray([]),
      planning_file: new FormControl(),
      planning_file_title: new FormControl(),
      etape_porteur_1: new FormControl(),
      etape_porteur_2: new FormControl(),
    });


    this.add_palettes_form = this.fb.group({
      chargees: new FormControl(),
      rendues: new FormControl(),
      livrees: new FormControl(),
      reprises: new FormControl(),
      type: new FormControl(),
      warehouse_id: new FormControl(),
      warehouse_shipping_id: new FormControl(),
    });

    this.billing_form_arr = this.planning_form.get('state_billing') as FormArray;
    this.palettes_form = this.fb.group({
      palettes: this.fb.array([])
    });
  }
  
  
  //on patch les checkbox de facturations
  
  private _patchValues(response) {
    let toPatch = {
      departure_id: response.departure_id,
      arrival_id: response.arrival_id,
      loading_place: response.loading_place,
      loading_hour: response.loading_hour,
      ref_loading:response.ref_loading,
      shipping_place: response.shipping_place,
      shipping_hour:response.shipping_hour,
      ref_delivery: response.ref_delivery,
      etape_porteur_1: response.etape_porteur_1,
      etape_porteur_2: response.etape_porteur_2,
      provider_payment_date: response.provider_payment_date,
      client_payment_date: response.client_payment_date,
      ref_client: response.ref_client,
      pal_livrees: response.pal_livrees,
      pal_chargees: response.pal_chargees,
      pal_rendues: response.pal_rendues,
      pal_reprises: response.pal_reprises,
    }
    this.planning_form.patchValue(toPatch);
    //reset cases
    while (this.billing_form_arr.length !== 0) {
      this.billing_form_arr.removeAt(0)
    }
    let billing = '';

    if (response.state_billing)
      billing = response.state_billing.split(',');
  
    this.statuses.forEach((status, index) => {
      
      let checked = (billing.indexOf(index.toString()) != -1) ? true : false;
      this.billing_form_arr.push(
        new FormGroup(
          {
            name: new FormControl(status.name),
            checked: new FormControl(checked),
          }
        )
      );
    });
  }
// maj des observations
  updateNote(planning_id, event) {
    var value = event.target.parentElement.parentElement.getElementsByTagName("TEXTAREA")[0].value;
    var params = {};
    params["note"] = value;
    this.service.updatePlanning(planning_id, params).subscribe((response) => {
      this.closeModal();
    });
  }

  //get planning palettes
  getPlanningPalettes(planning_id) {
    this.resetItemsFormArray();

    this.planningPalettesService.getPlanningPalettes(planning_id).subscribe(
      (response) => {
        this.planning_palettes = response;


        let index = 0;

        for (let palette of response) {
          const item = this.fb.group({
            id: palette.id,
            chargees: palette.chargees,
            rendues: palette.rendues,
            livrees: palette.livrees,
            reprises: palette.reprises,
          });
          this.itemsFormArray.push(item);
          this.planning_palettes[index] = { ...this.planning_palettes[index], total_geofret: (palette.rendues - palette.chargees) };
          this.planning_palettes[index] = { ...this.planning_palettes[index], total_entrepot: (palette.reprises - palette.livrees) };
          index++;
          //this.planning_palettes
        }
      },
      (error) => {
        //console.log("this.getPlanningPalettes.getPlanningPalettes error:", error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de la récupération des palettes du planning.`,
           false,
          "Récupération des palettes"
        );
      }
    );
  }
  
  handlePlanningFileInput(files: FileList) {
    this.planningFileToUpload = files.item(0);
  }

  // Get planning files
  getPlanningFiles(planning_id) {
    this.planningFilesService.getPlanningFiles(planning_id).subscribe(
      (response) => {
        //console.log("this.planningFilesService.getPlanningFiles response:", response);
        this.planning_files = response;
      },
      (error) => {
        console.log("this.planningFilesService.getPlanningFiles error:", error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de la récupération des documents du planning.`,
          false,
          "Récupération des documents"
        );
      }
    );
  }

  // Add planning file
  addPlanningFile(planning_id, data) {
    if (!this.planningFileToUpload) {
      this.toast.error("Veuillez sélectionner un fichier.", false, "Ajout d'un document"); return;
    }
    if (!data.planning_file_title || !data.planning_file_title.trim().length) {
      this.toast.error("Veuillez indiquer un titre.", false, "Ajout d'un document"); return;
    }

    var body = new FormData();
    body.append("planning_id", planning_id);
    body.append("planning_file_title", data.planning_file_title);
    body.append("file", this.planningFileToUpload);

    this.addPlanningFileLoading = true;

    this.planningFilesService.addPlanningFile(body).subscribe(
      (response) => {
        //console.log("this.planningFilesService.addPlanningFile response:", response);
        this.resetPlanningFileData();
        this.toast.success(`Le document '${data.planning_file_title}' a été ajouté avec succès'`, false, "Ajout d'un document");
        this.getPlanningFiles(planning_id); // Update planning files list
        this.addPlanningFileLoading = false;
        this.updatePlanningFiles.emit({ planning_file: response, isDeleted: false});
      },
      (error) => {
        console.log("this.planningFilesService.addPlanningFile error:", error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de l'ajout de votre document.`,
          false,
          "Ajout d'un document"
        );
        this.addPlanningFileLoading = false;
      }
    );
  }

  deletePlanningFile(planning_file) {
    if (confirm(`Êtes-vous sûr de vouloir supprimer le document '${planning_file.title}' ?`)) {
      this.deletePlanningFileLoadingID.push(planning_file.id);
      this.planningFilesService.deletePlanningFile(planning_file).subscribe(
        (response) => {
          //console.log("this.planningFilesService.deletePlanningFile response:", response);
          this.toast.success(`Le document '${planning_file.title}' a été supprimé avec succès'`, false, "Suppression d'un document");
          this.getPlanningFiles(this.planning_id); // Update planning files list
          this.deletePlanningFileLoadingID = this.deletePlanningFileLoadingID.filter(x =>  x != planning_file.id);
          this.updatePlanningFiles.emit({ planning_file: response, isDeleted: true});
        },
        (error) => {
          console.log("this.planningFilesService.deletePlanningFile error:", error);
          this.toast.error(
            error.error && error.error.message 
              ? error.error.message 
              : `Une erreur est survenue lors de la suppression du document '${planning_file.title}'.`,
            false,
            "Suppression d'un document"
          );
          this.deletePlanningFileLoadingID = this.deletePlanningFileLoadingID.filter(x =>  x != planning_file.id);
        }
      );
    }
  }

  openPlanningFile(planning_file) {
    const API_URI = this.planningFilesService.getApiURI();
    window.open(`${API_URI}/${planning_file.filename}`);
  }

  // Reset planningFile data/inputs
  resetPlanningFileData() {
    this.planningFileToUpload = null;
    this.planning_files = null;
    this.planning_form.get('planning_file').reset();
    this.planning_form.get('planning_file_title').reset();
  }

  //ouverture modal
  //openModal(planning_id: number) {
  openModal(planning_id:number) {
    this.planning_id = planning_id;
    this.is_admin = this.security.isAdmin();

    this.resetItemsFormArray();
    this.getPlanningPalettes(this.planning_id);
    this.getPlanningDetail(this.planning_id);
    this.resetPlanningFileData();
    this.getPlanningFiles(this.planning_id);

    
    jQuery('#planning_infos').modal('show');
    jQuery('.menu .item').tab();
  }

  //close modal and refresh planing
  closeModal() {
    jQuery('#planning_infos').modal('hide');
    //this.refresh.emit(true);
  }

  //recup du contenu planning pour la modal
  getPlanningDetail(planning_id: number) {
    this.service.getPlanningDetail(planning_id).subscribe((response) => {
      if (response.provider_payment_date)
        this.provider_payment_date = moment(response.provider_payment_date).locale('fr').format('ddd D-MM-y');

      if (response.client_payment_date)
        this.client_payment_date = moment(response.client_payment_date).locale('fr').format('ddd D-MM-y');


      this.planning = response;
      //console.log(this.planning);
      this._patchValues(response);
    });
  }

  //maj du planning (checkboxes sur la facturation)
  async updatePlanning(planning_id, data)
  {
    let arrChecked = []; 
    if (data.state_billing)
    {
      data.state_billing.forEach(function (element, index) {
        if (element.checked)
          arrChecked.push(index);
      })
    }
    data.state_billing = arrChecked.join(',');

    //format dates de factu
    if (data.provider_payment_date) {
      data.provider_payment_date = data.provider_payment_date.formatted;
    }
    if (data.client_payment_date) {
      data.client_payment_date = data.client_payment_date.formatted;  
    }

    let departure_id = data.departure_id;
    let arrival_id = data.arrival_id;
    let qty = data.quantity;


    let co2_emitted = await this.calculateCO2(departure_id, arrival_id, qty);
    console.log("co2_emitted", co2_emitted);
    data.co2_emitted = co2_emitted;
    
    console.log("data", data);
    this.service.updatePlanning(planning_id, data).subscribe((response) => {
      this.closeModal();
    });
  }

  updateProviderPaymentDate(event, planning) {
    this.service
      .updatePlanning(planning.id, {
        provider_payment_date: new Date(event.jsdate).toLocaleDateString(),
      }).subscribe((response) => {
    });
  }
  updateClientPaymentDate(event, planning) {
    this.service
      .updatePlanning(planning.id, {
        client_payment_date: new Date(event.jsdate).toLocaleDateString(),
      }).subscribe((response) => {
    });
  }

  onSubmitPaletteForm() {
    this.palettes_form.disable();
    
    this.planningPalettesService.updatePalettes(this.palettes_form.value).subscribe((response) => {
      this.palettes_form.enable();
    });
  }

  enableEditMode(palette: any): void {
    palette.editMode = true;
  }

  disableEditMode(palette: any): void {
    palette.editMode = false;
  }

  updateChargement(event, planningPalette: any, item): void {
   
    this.planningPalettesService
      .updatePalette(planningPalette.id, { warehouse_id: event.id })
      .subscribe((response) => {

        planningPalette.warehouse.name = event.name;
        this.disableEditMode(item);
    });
    
  }
  updateLivraison(event, planningPalette: any, item): void {
    this.planningPalettesService
      .updatePalette(planningPalette.id, { warehouse_shipping_id: event.id })
      .subscribe((response) => {
        planningPalette.warehouse_shipping.name = event.name;
        this.disableEditMode(item);
    });
  }

  saveItem() {
    this.planningPalettesService.createPalette(this.add_palettes_form.value, this.planning_id).subscribe((response) => {
      this.add_palettes_form.reset();
      this.getPlanningPalettes(this.planning_id);
    });
  }

  async calculateDistance(departureCityId: number, arrivalCityId: number): Promise <number> {
    try {
      // Obtenir les coordonnées des villes à partir de leurs IDs
      const coordinates = await this.distanceService.getCoordinatesByCityIds(departureCityId, arrivalCityId);
      console.log("coordinates", coordinates);
      // Calculer la distance entre les deux villes
      const distance = await this.distanceService.calculateDistance(coordinates.departure, coordinates.arrival);
      console.log("distance", distance);
      return distance;
    } catch (error) {
      console.error('Erreur lors du calcul de la distance', error);
    }
  }

  async calculateCO2(departure_id: number, arrival_id: number, quantity: number): Promise<number> { 
   
    const distance = await this.calculateDistance(departure_id, arrival_id);
    const etapePorteur1 = this.planning_form.get('etape_porteur_1').value;
    const etapePorteur2 = this.planning_form.get('etape_porteur_2').value;
    
    let co2Emission = 0;

    if (quantity > 20 && quantity <= 33) {
      // Camion complet
      co2Emission = await this.calculateFullTruckCO2(distance)
      
    } else if (quantity < 20) {
      // Groupage
      co2Emission = await this.calculateGroupedTruckCO2(etapePorteur1, etapePorteur2, distance, quantity); // Calcul pour un camion en groupage
    }

    return co2Emission;
  }

  async calculateFullTruckCO2(distance: number): Promise<number> {
    try {
      // Récupérer la consommation du véhicule
      const consoVehiculeResponse = await this.configService.getConfigByKey('conso_vehicule').toPromise();
      const conso_vehicule = consoVehiculeResponse.value;
      console.log('Conso véhicule:', conso_vehicule);

      // Récupérer l'indice de rejet
      const indiceRejetResponse = await this.configService.getConfigByKey('indice_rejet').toPromise();
      const indice_rejet = indiceRejetResponse.value;
      console.log('Indice de rejet:', indice_rejet);

      // Calcul du rejet de CO2
      const rejet = (conso_vehicule * distance / 100) * indice_rejet;
      console.log('Rejet:', rejet);
      return rejet;

    } catch (error) {
      console.error('Erreur lors de la récupération des configs:', error);
      return 0; // Retourner 0 en cas d'erreur
    }
  }

  async calculateGroupedTruckCO2(etapePorteur1: number, etapePorteur2: number, distance: number, qty: number): Promise<number> {
    //conso_vehicule_porteur1 x nb km / 100 x %de palette (/20) x indece de rejet
    //conso_Vehicule x nb km / 100 x %de palette(/33) x indece de rejet
    //conso_vehicule_porteur2 x nb km / 100 x %de palette (/20) x indece de rejet
    try {
      // Récupérer la consommation du véhicule
      const consoVehiculeResponse = await this.configService.getConfigByKey('conso_vehicule').toPromise();
      const conso_vehicule = consoVehiculeResponse.value;
      console.log('Conso véhicule:', conso_vehicule);

      // Récupérer l'indice de rejet
      const indiceRejetResponse = await this.configService.getConfigByKey('indice_rejet').toPromise();
      const indice_rejet = indiceRejetResponse.value;
      console.log('Indice de rejet:', indice_rejet);

      const consoVehiculePorteurResponse = await this.configService.getConfigByKey('conso_vehicule_porteur').toPromise();
      const conso_vehicule_porteur = consoVehiculePorteurResponse.value;
      console.log('Conso véhicule Porteur:', conso_vehicule_porteur);

      //Trajet porteur 1
      const percentPalette = qty/20;
      const etape1 = conso_vehicule_porteur * etapePorteur1 / 100 * percentPalette * indice_rejet
      //trajet porteur 2
      const etape2 = conso_vehicule_porteur * etapePorteur2 / 100 * percentPalette * indice_rejet
      //trajet central
      const rejet = (conso_vehicule * distance / 100) * indice_rejet;
      
      const total = etape1 + etape2 + rejet;
      console.log('Rejet:', total);
      return total;

    } catch (error) {
      console.error('Erreur lors de la récupération des configs:', error);
      return 0; // Retourner 0 en cas d'erreur
    }
  }
}


// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/planning/planning-modal/planning-modal.component.ts